<template>
  <div class="footer-inner">
    <p class="copyright">&copy; Click &lsquo;em Quick {{ currentYear }}</p>
  </div>
</template>

<script>
export default {
  name: 'MainFooter',
  computed: {
    currentYear: function() {
      return new Date().getFullYear();
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.footer-inner {
  margin: 0 auto;
  max-width: var(--max-width-site);
  padding: var(--padding-xs);
  width: 100%;
}
.copyright {
  font-size: 1.2rem;
  margin: 0;
  min-width: 100%;
  text-align: center;
  width: 100%;
}
</style>
